import { z } from 'zod';
/** Perfiles de entidad (los mismos de Planning). */
export const EntityProfile = { COMPANY: 'COMPANY', PUBLIC_ENTITY: 'PUBLIC_ENTITY', NGO: 'NGO' };
export const entityProfileSchema = z.enum(['COMPANY', 'PUBLIC_ENTITY', 'NGO']);
export const ENTITY_PROFILE_LABEL = { COMPANY: 'Empresa', PUBLIC_ENTITY: 'Entidad pública', NGO: 'ONG o fundación' };
/** Rol de la persona dentro de la entidad (los permisos finos son de cada app). */
export const EntityRole = { ADMIN: 'ADMIN', MEMBER: 'MEMBER' };
export const entityRoleSchema = z.enum(['ADMIN', 'MEMBER']);
export const PlatformRole = { NONE: 'NONE', SUPERADMIN: 'SUPERADMIN' };
/** Identificador de la entidad: minúsculas, números y guiones, empezando por letra. El mismo en todas las apps. */
export const ENTITY_SLUG = /^[a-z][a-z0-9-]{1,30}$/;
export const entitySlugSchema = z.string().regex(ENTITY_SLUG, 'Identificador inválido: minúsculas, números y guiones, empezando por una letra');
/** Código de app: `planning`, `sgdea`, `erp`… */
export const APP_CODE = /^[a-z][a-z0-9-]{1,30}$/;
export const appCodeSchema = z.string().regex(APP_CODE, 'Código de app inválido');
/** Scope que trae los claims de la suite. Las apps piden `openid email profile xiltrion`. */
export const SUITE_SCOPE = 'xiltrion';
export const SUITE_SCOPES = ['openid', 'email', 'profile', 'xiltrion', 'offline_access'];
/** Claims que la suite pone en el id_token y en /oidc/me (spec §4). `sub` es `<uid>:<tenant>`. */
export const suiteClaimsSchema = z.object({
    sub: z.string(),
    uid: z.string().uuid(),
    email: z.string().email(),
    email_verified: z.boolean().optional(),
    name: z.string(),
    tenant: entitySlugSchema,
    tenant_name: z.string(),
    tenant_profile: entityProfileSchema,
    apps: z.array(appCodeSchema),
    modules: z.array(z.string()),
    role: entityRoleSchema,
    platform_role: z.enum(['NONE', 'SUPERADMIN']).default('NONE'),
});
/** `sub` → { uid, tenant }. */
export function parseSubject(sub) {
    const i = sub.indexOf(':');
    if (i <= 0)
        throw new Error(`sub de la suite inválido: ${sub}`);
    return { uid: sub.slice(0, i), tenant: sub.slice(i + 1) };
}
export const makeSubject = (uid, tenant) => `${uid}:${tenant}`;
/** Lee y valida los claims de un id_token de la suite (lo que devuelve `tokens.claims()` de openid-client). */
export function parseSuiteClaims(claims) {
    return suiteClaimsSchema.parse(claims);
}
//# sourceMappingURL=claims.js.map